import { UIHeading2, UIText1, useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import React from 'react';
import styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Form = function Form(_ref) {
  var onSubmit = _ref.onSubmit,
    title = _ref.title,
    subtitle = _ref.subtitle,
    children = _ref.children;
  var deviceType = useDeviceType();
  return /*#__PURE__*/_jsxs("form", {
    className: cn(styles['form'], styles[deviceType]),
    onSubmit: onSubmit,
    "data-testid": "leave-contacts-modal-form",
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['form-title'],
      children: /*#__PURE__*/_jsx(UIHeading2, {
        whiteSpace: "pre-line",
        children: title
      })
    }), /*#__PURE__*/_jsx("div", {
      className: cn(styles['form-subtitle'], styles[deviceType]),
      children: /*#__PURE__*/_jsx(UIText1, {
        color: "gray60_100",
        whiteSpace: "pre-line",
        children: subtitle
      })
    }), children]
  });
};